// extracted by mini-css-extract-plugin
module.exports = {"ColorPrimary":"#0079c1"};